import "../../../assets/styles/subscriptions-tab.scss";

import { Box } from "@mui/system";
import { useContext } from "react";

import SubscriptionsList from "./subscriptions-list";
import SubscriptionsDetails from "./subscriptions-details";
import APIContext from "../../../services/api/api";

export default function Subscriptions() {
  const { currentSubscriptionView } = useContext(APIContext);

  return (
    <Box style={{ padding: 0 }}>
      {currentSubscriptionView.screen === "subscriptionsList" ? (
        <SubscriptionsList />
      ) : (
        <SubscriptionsDetails />
      )}
    </Box>
  );
}
